/* eslint-disable @typescript-eslint/no-explicit-any */
import pluralize from 'pluralize'
import { toHeaderCase } from 'js-convert-case'
import { IterationAdditionalProps, FieldSchemaRowType } from './types'

const getDataGetterFromSchema =
  (schema: Record<string, any>) =>
  (
    key: string,
    {
      parentApiKeys = [],
      parentType = '',
      iterator = 0,
    }: IterationAdditionalProps = {},
  ) => {
    const field = schema[key]
    const fieldData = {
      title: field?.title || toHeaderCase(key),
      apiKey: [...parentApiKeys, key],
      type: setFieldType(field),
      description: field?.description || null,
      parentType: parentType,
      iterator: iterator,
    }

    let childrenData: Array<FieldSchemaRowType> = []

    if (field?.type === 'object') {
      childrenData = iterateFieldSchema(field?.properties, {
        parentApiKeys: fieldData.apiKey,
        parentType: 'object',
        iterator: iterator + 1,
      })
    }

    if (field?.type === 'array') {
      childrenData = iterateFieldSchema(field?.items?.properties, {
        parentApiKeys: [],
        parentType: 'array',
        iterator: iterator + 1,
      })
    }

    return [fieldData, ...childrenData]
  }

export function iterateFieldSchema(
  schema: Record<string, any>,
  iterationProps: IterationAdditionalProps = {},
) {
  if (!schema) return []

  return Object.keys(schema as Record<string, any>).reduce((acc, key) => {
    const getDataFromField = getDataGetterFromSchema(schema)
    const fieldData = getDataFromField(key, iterationProps)
    return [...acc, ...fieldData]
  }, [] as Array<FieldSchemaRowType>)
}

function setFieldType(field: Record<string, any>) {
  const arrayItemsType = field?.items?.type
  if (!arrayItemsType) return field?.type

  if (arrayItemsType === 'object') {
    return `items`
  } else {
    return `array of ${pluralize(arrayItemsType)}`
  }
}

export function calculateLeftPadding(value: number) {
  return {
    '--field-schema-level': value,
    '--base-padding-left': '12px',
    paddingLeft: `calc(var(--base-padding-left) + (var(--field-schema-level) * 16px))`,
  }
}
